import { ShieldCheck, Flame, BadgePercent } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { FACTORY_IMG } from "@/data/site";

const POINTS = [
  { icon: ShieldCheck, text: "Legalitas kayu terjamin SVLK & Perhutani" },
  { icon: Flame, text: "Pengeringan oven kiln-dried, kadar air < 12%" },
  { icon: BadgePercent, text: "Harga distributor langsung dari pabrik" },
];

export const About = () => (
  <section id="tentang" data-testid="about-section" className="surface relative overflow-hidden py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <p className="overline-label mb-4">Tentang Kami</p>
        <h2 className="font-serif text-3xl tracking-tight text-brand-ink sm:text-4xl lg:text-5xl">
          Dari Hutan Legal, <span className="italic accent-text">ke Proyek Anda.</span>
        </h2>
        <p className="mt-6 text-base leading-relaxed text-brand-muted">
          PT. SINAR AL MUBAROKAH adalah pabrik kayu olahan Indonesia sekaligus distributor utama
          triplek, multiplek, dan kayu solid. Sebagai supplier kayu olahan proyek bangunan
          terpercaya, kami menyuplai grosir kayu konstruksi proyek untuk kontraktor, developer,
          mebel, hingga perorangan di seluruh nusantara.
        </p>
        <p className="mt-4 text-base leading-relaxed text-brand-muted">
          Setiap batang kayu melewati seleksi ketat dan pengeringan presisi sebelum dikirim —
          memastikan produk bebas lapuk, bebas rayap, dan stabil dimensinya.
        </p>
        <ul className="mt-8 space-y-4">
          {POINTS.map((p) => (
            <li key={p.text} className="flex items-center gap-4">
              <span
                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl"
                style={{ backgroundColor: "color-mix(in srgb, var(--t-accent) 15%, transparent)", color: "var(--t-accent)" }}
              >
                <p.icon size={20} />
              </span>
              <span className="text-sm font-semibold text-brand-ink">{p.text}</span>
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal delay={0.15} className="relative">
        <div className="overflow-hidden rounded-[2rem]">
          <img
            src={FACTORY_IMG}
            alt="Pekerja pabrik kayu olahan PT. SINAR AL MUBAROKAH"
            className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
          />
        </div>
        <div
          className="card-surface absolute -bottom-6 -left-4 rounded-2xl px-7 py-5 shadow-2xl sm:-left-8"
          data-testid="about-experience-badge"
        >
          <p className="font-serif text-4xl font-semibold accent-text">15+</p>
          <p className="text-xs uppercase tracking-wider text-brand-muted">Tahun Melayani Indonesia</p>
        </div>
      </Reveal>
    </div>
  </section>
);
